module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "users"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "empty-text": "No users"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "Username",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email",
      "header-align": "center",
      "class-name": "email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "role",
      "label": "Role",
      "header-align": "center",
      "formatter": _vm.humaniseRole
    }
  }), _vm._v(" "), (_vm.userIsSuperAdmin) ? _c('el-table-column', {
    attrs: {
      "prop": "client_id",
      "label": "Client",
      "header-align": "center",
      "formatter": _vm.humaniseClient
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operations",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('operations', {
          attrs: {
            "id": props.row.id,
            "disableMore": true
          },
          on: {
            "edit": function($event) {
              _vm.editUser(props.row)
            },
            "delete": function($event) {
              _vm.deleteUser(props.row)
            }
          }
        })]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aad800a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Users/UserTable.vue
// module id = 1146
// module chunks = 0